import { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import withStyles from 'beam/dist/styles'

// Use this to prevent XSS, allowed tags are as follows: https://github.com/punkave/sanitize-html#what-are-the-default-options
import sanitize from 'sanitize-html'

const phraseHitColor = 'yellow'
const userSearchColor = 'pink'
const userSearchSelectedColor = 'salmon'

const styles = theme => ({
  content: {
    ...theme.typography.body2,
    '&:focus': {
      outline: 'none',
    },
  },
  phraseHit: {
    background: phraseHitColor,
    color: 'black',
    '&:hover': {
      background: 'orange',
    },
  },
  userSearch: {
    background: userSearchColor,
  },
  userSearchSelected: {
    background: userSearchSelectedColor,
  },
  light: {
    color: theme.palette.common.white,
  },
})

/**
 * Single message divided into clumps with phrase and search hits highlighted
 */

const ChatText = ({ clumps, classes, queryCurrentIndex, variant }) => {

  const isLight = variant === 'light'

  return (
    <Fragment>
      {clumps.map((clump, idx) => (
        <span
          key={idx}
          tabIndex={-1}
          className={classNames(
            isLight && !clump.hit && classes.light,
            classes.content,
            clump.hit && classes.phraseHit,
            clump.qHit && classes.userSearch,
            clump.qHit && clump.qIndex === queryCurrentIndex ? classes.userSearchSelected : null,
          )}
          dangerouslySetInnerHTML={{
            __html: sanitize(clump.words),
          }}
        />
      ))}
    </Fragment>
  )
}

ChatText.propTypes = {
  clumps: PropTypes.array.isRequired,
  queryCurrentIndex: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(['dark', 'light']),
}

ChatText.defaultProps = {
  variant: 'dark',
}

export { ChatText as UnstyledChatText }
export default withStyles(styles)(ChatText)
